var map = {
	"./avatar.jpg": 94,
	"./bike-rental-system.JPG": 208,
	"./blazor-traffic.JPG": 209,
	"./ddd-architecture.jpg": 210,
	"./documents-flow.JPG": 211,
	"./flight-system.JPG": 212,
	"./graphooo.JPG": 213,
	"./makasa-store.JPG": 214,
	"./microservices-architecture.JPG": 215,
	"./ng-api-template.JPG": 216,
	"./personal-portfolio.JPG": 217,
	"./product-store.JPG": 218,
	"./softuni-courses.JPG": 219,
	"./swapp.JPG": 220,
	"./tracking-system.JPG": 221,
	"./vba-tools.JPG": 222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 207;